import { Status } from '../types';

export const getInputStatus = (
  disabled: boolean,
  hasError: boolean
): Status => {
  if (disabled) return 'disabled';
  if (hasError) return 'error';
  return 'active';
};
